<template>
  <div class="about">
    <div class="headBox">
      <div class="head">
        <img
          src="../assets/images/items/item1/quit.png"
          alt=""
          @click="goHome"
          class="img1"
        />
      </div>
    </div>

    <div class="head-img">
      <img src="../assets/images/items/item1/headImg.png" alt="" />
    </div>
    <div class="head-content">
      <!-- <div class="title">
        <img src="../assets/images/items/item2/title.png" alt="" />
      </div> -->
      <!-- <div class="icon">
        <img src="../assets/images/items/item2/timePlace.png" alt="" />
      </div> -->
      <!-- <div class="content">
        <img src="../assets/images/items/item2/introduce.png" alt="" />
      </div> -->

      <div class="text-title">
        <h2 class="font-bold l-s-75">北京世园会中国馆</h2>
      </div>

      <div class="text-icon">
        <img src="../assets/images/items/item1/icon.png" alt="" class="img" />
        <span class="didian font-regular l-s-75">北京</span>
        <span class="time font-regular l-s-75">2019</span>
      </div>

      <div class="text-content">
        <p class="font-light l-s-75">
          北京世界园艺博览会中国馆以生生不息为理念、以锦绣中华为意象，以园艺植物为载体、以生态人文为核心，以六“和”九幕讲述中国生态故事。
        </p>
        <p class="font-light l-s-75">
          设计展线清晰而明快，内容上采用递进式叙事方式，展示主题逐步升华和提升，让参观者深刻感受大自然力量的原始震撼之美，彰显中国当代生态文明建设成果。
        </p>
        <p class="font-light l-s-75">
          展览形式新颖，引人入胜，通过多媒体系统将动态演绎与静态展示相结合，虚拟意境与实物花卉相呼应，当代科技与传统艺术相融汇，表现人与自然和谐共生的中国生态文化。
        </p>
        <p class="font-light l-s-75">
          该项目获得2019亚太室内设计精英邀请赛杰出设计奖获和2019-2020年度北京市建筑装饰工程优秀设计奖。
        </p>
      </div>

      <!-- <div class="roam">
        <img
          src="../assets/images/items/item1/panoramicRoaming.png"
          alt=""
          @click="goRoam('RZFY')"
        />
      </div> -->
    </div>

    <div class="items">
      <div class="item">
        <div class="title">
         <p class="font-regular l-s-75"> &nbsp;</p>
        </div>
        <div class="content">
          <img
            src="../assets/images/items/item1/shiyuanhui big (1).jpg"
            alt=""
          />
        </div>
      </div>

      <div class="item">
        <div class="title">
         <p class="font-regular l-s-75"> &nbsp;</p>
        </div>
        <div class="content">
          <img
            src="../assets/images/items/item1/shiyuanhui big (2).jpg"
            alt=""
          />
        </div>
      </div>

      <div class="item">
        <div class="title">
         <p class="font-regular l-s-75"> &nbsp;</p>
        </div>
        <div class="content">
          <img
            src="../assets/images/items/item1/shiyuanhui big (3).jpg"
            alt=""
          />
        </div>
      </div>

      <div class="item">
        <div class="title">
         <p class="font-regular l-s-75"> &nbsp;</p>
        </div>
        <div class="content">
          <img
            src="../assets/images/items/item1/shiyuanhui big (4).jpg"
            alt=""
          />
        </div>
      </div>

      <div class="item">
        <div class="title">
         <p class="font-regular l-s-75"> &nbsp;</p>
        </div>
        <div class="content">
          <img
            src="../assets/images/items/item1/shiyuanhui big (5).jpg"
            alt=""
          />
        </div>
      </div>

      <div class="item">
        <div class="title">
         <p class="font-regular l-s-75"> &nbsp;</p>
        </div>
        <div class="content">
          <img
            src="../assets/images/items/item1/shiyuanhui big (6).jpg"
            alt=""
          />
        </div>
      </div>

      <div class="item">
        <div class="title">
         <p class="font-regular l-s-75"> &nbsp;</p>
        </div>
        <div class="content">
          <img
            src="../assets/images/items/item1/shiyuanhui big (7).jpg"
            alt=""
          />
        </div>
      </div>

      <div class="item">
        <div class="title">
         <p class="font-regular l-s-75"> &nbsp;</p>
        </div>
        <div class="content">
          <img
            src="../assets/images/items/item1/shiyuanhui big (8).jpg"
            alt=""
          />
        </div>
      </div>

      <div class="item">
        <div class="title">
         <p class="font-regular l-s-75"> &nbsp;</p>
        </div>
        <div class="content">
          <img
            src="../assets/images/items/item1/shiyuanhui big (9).jpg"
            alt=""
          />
        </div>
      </div>

      <div class="item">
        <div class="title">
         <p class="font-regular l-s-75"> &nbsp;</p>
        </div>
        <div class="content">
          <img
            src="../assets/images/items/item1/shiyuanhui big (10).jpg"
            alt=""
          />
        </div>
      </div>
    </div>

     <div class="home-footer">
      <img src="../assets/images/part5/logo.png" alt="" />
    </div>
  </div>
</template>

<script >
import store from "../store";
import { mapState, mapMutations } from "vuex";
export default {
  name: "About0",
  data() {
    return {};
  },
  computed: {
    ...mapState(["about0Data"]),
  },
  methods: {
    ...mapMutations(["setAbout0Scrolltop"]),
    goHome() {
      this.$router.replace("/");
    },
    goVideo(data) {
      this.$router.replace({
        name: "Video",
        params: {
          video: data,
          about: this.$route.params.id,
        },
      });
    },
    goRoam(data) {
      this.$router.replace({
        name: "Roam",
        params: {
          name: data,
          about: this.$route.params.id,
        },
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$nextTick(() => {
        let bodySrcollTop = document.body.scrollTop;
        if (bodySrcollTop || bodySrcollTop == 0) {
          document.body.scrollTop = store.state.about0Data.scrollTop;
        }
        let docSrcollTop = document.documentElement.scrollTop;
        if (docSrcollTop || docSrcollTop == 0) {
          document.documentElement.scrollTop = store.state.about0Data.scrollTop;
        }
      });
    });
  },
  beforeRouteLeave(to, from, next) {
    // window.removeEventListener('scroll', this.windowScroll)
    // console.log(this.scrollTop);
    // this.setHomeScrolltop(this.scrollTop);
    let scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;

    if (to.name == "Video" || to.name == "Roam") {
      this.setAbout0Scrolltop(scrollTop);
    } else if (to.name == "Home") {
      this.setAbout0Scrolltop(0);
      // 这里可以写销毁组件
    }
    next();
  },
  mounted() {
    // console.log(111);
    let videos = document.querySelectorAll(".about video");
    // console.log(videos);
    for (let i = 0; i < videos.length; i++) {
      videos[i].addEventListener("play", function () {
        for (let j = 0; j < videos.length; j++) {
          if (videos[j] != this) {
            videos[j].pause();
          }
        }
      });
    }
  },
};
</script>

<style scoped>
.about {
  width: 100vw;
  max-width: 750px;
  margin: 0 auto;
  background-color: black;
}

.headBox {
  height: 0.6rem;
  width: 100%;
}

.head {
  width: 100vw;
  max-width: 750px;
  margin: 0 auto;
  height: 0.6rem;
  background-image: url("../assets/images/items/item2/head.png");
  background-size: cover;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%);
  z-index: 999;
}

.head img {
  width: 1.18rem;
  height: 0.48rem;

  margin-top: 0.06rem;
}

.head .img1 {
  float: left;
  margin-left: 0.12rem;
}
.head .img2 {
  float: right;
  margin-right: 0.12rem;
}

.head-img {
  width: 100%;
}
.head-img img {
  width: 100%;
}

.head-content {
  width: 100%;
}

.head-content .title {
  width: 80%;
  margin: 0 auto;
}
.head-content .title img {
  width: 100%;
}

.head-content .icon {
  width: 30%;
  margin: 0 auto;
}
.head-content .icon img {
  width: 100%;
}
.head-content .content {
  width: 75%;
  margin: 0 auto;
  margin-top: 0.36rem;
}
.head-content .content img {
  width: 100%;
}

.head-content .roam {
  width: 25%;
  margin: 0 auto;
  margin-top: 0.18rem;
}
.head-content .roam img {
  width: 100%;
}

.items {
  width: 100%;
  margin-top: 0.95rem;
}

.items .item {
  margin-top: 0.24rem;
}
.items .item .title {
  text-align: left;
}
.items .item .title img {
  margin-left: 10%;
}
.items .item .title .img-title {
  width: 60%;
}
.items .item .title .img-content {
  width: 70%;
  margin-top: 0.12rem;
}

.items .item .title p {
  /* width: 80%; */
  font-size: 0.19rem;
  color: #fff;
  margin-left: 10%;
}
.items .item .content {
  text-align: center;
}
.items .item .content img {
  /* max-width: 100%; */
  /* max-height: 100px; */
  width: 100%;
  margin-top: 0.12rem;
}

.items .item .content .video {
  position: relative;
}

.items .item .content .video .week {
  position: absolute;
  top: 0.12rem;
  right: 0.12rem;
  z-index: 300;
}

.items .item .content .video .week img {
  width: 0.59rem;
  cursor: pointer;
}

.items .item .content video {
  width: 100%;
  margin-top: 0.12rem;
}

/* 文字替换图片 */
.head-content .text-title {
  color: #fff;
  margin-top: 0.36rem;
  font-size: 0.24rem;
}
.head-content .text-icon {
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.16rem;
  margin-top: 0.18rem;
}
.head-content .text-icon .img {
  width: 0.24rem;
}
.head-content .text-icon .didian {
  margin-right: 0.24rem;
}
.head-content .text-content {
  color: #fff;
  margin-top: 0.4rem;
  padding: 0 0.25rem;
  font-size: 0.16rem;
  text-align: left;
  text-indent: 2em;
}
.head-content .text-content p {
  margin-bottom: 0.08rem;
}

/* 字体样式 */
.items .test-title {
  border-left: 0.05rem solid #fff;
  padding-left: 0.05rem;
}

.l-s-75 {
  letter-spacing: 2.5px;
}

.items .item .title p{
  font-size: 0.25rem;
}

/* 页尾 */
.home-footer {
  width: 100%;
  background-color: black;
  padding-top: 0.5rem;
  padding-bottom: 0.1rem;
  text-align: left;
}

.home-footer img {
  width: 50%;
  margin-left: 0.3rem;
}
</style>
